import { NgModule, Inject, DOCUMENT } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/components/header/header.component';
import { FooterComponent } from './common/components/footer/footer.component';
import { CustomerCareModule } from './modules/customer-care/customer-care.module';
import { NgIdleModule } from '@ng-idle/core';
import { DomService } from './common/services/dom.service';
import { ModalService } from './common/services/modal.service';
import { UrlSerializer } from '@angular/router';
import { CustomUrlSerializer } from './app.customUrlSerializer';
import { FormsModule } from '@angular/forms';
import { NgClickOutsideModule } from 'ng-click-outside2';
import { SearchResultsComponent } from './search-results/search-results.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchService } from './common/services/search.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CCMaterialModule } from './modules/customer-care/cc-material.module';
import { PublicComponent } from './common/components/public-page/public/public.component';
import { PublicHeaderComponent } from './common/components/public-page/public-header/public-header.component';
import { PublicFooterComponent } from './common/components/public-page/public-footer/public-footer.component';
import { SearchPageComponent } from './common/components/search-page/search-page.component';
import { TranslateModule, TranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageService } from './common/services/language-service';
import { UIBaseService } from './common/services/uibase.service';

import { DropdownDirective, SubDropdownDirective, ProfileDropdownDirective } from './common/directives/dropdown.directive';
import { SearchpageHeaderComponent } from './common/components/search-page/searchpage-Header/searchpage-header.component';
import { PagePublicComponent } from './common/components/public-page/page-public/page-public.component';
import { PublicLatestNewsComponent } from './common/components/public-page/public-latest-news/public-latest-news.component';
import { KeyPipe } from './common/pipes/objectKeyValue.pipe';
import { FeedbackFormComponent } from './common/components/feedback-form/feedback-form.component';
import { DocsFeedbackFormComponent } from './common/components/docs-feedback-form/docs-feedback-form.component';
import { DocsSecondFeedbackFormComponent } from './common/components/docs-second-feedback-form/docs-second-feedback-form.component';
import { HighlightPipe } from './common/pipes/highlight.pipe';
import { ToasterMsgComponent } from './common/components/toaster-msg/toaster-msg.component';
import { CookieService } from 'ngx-cookie-service';

export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '/cs/cop/assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SearchResultsComponent,
    PublicComponent,
    PublicHeaderComponent,
    PublicFooterComponent,
    DropdownDirective,
    SubDropdownDirective,
    ProfileDropdownDirective,
    SearchPageComponent,
    SearchpageHeaderComponent,
    PagePublicComponent,
    PublicLatestNewsComponent,
    KeyPipe,
    HighlightPipe,
    FeedbackFormComponent,
    DocsFeedbackFormComponent,
    DocsSecondFeedbackFormComponent,
    ToasterMsgComponent
  ],
  imports: [
    CCMaterialModule,
    BrowserModule,
    AppRoutingModule,
    CustomerCareModule,
    TranslateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      isolate: true
    }),
    NgIdleModule.forRoot(),
    FormsModule,
    NgClickOutsideModule,
    NgxPaginationModule,
    ReactiveFormsModule
  ],
  providers: [
    ModalService,
    DomService,
    SearchService,
    LanguageService,
    {
      provide: UrlSerializer,
      useClass: CustomUrlSerializer
    },
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  localInfo: any;

  constructor(
    translate: TranslateService,
    uiB: UIBaseService,
    language: LanguageService,
    @Inject(DOCUMENT) private _document: Document
  ) {
    let lang: string = "";
    this.localInfo = uiB.getDataFromVar("localeInfo");
    if (this.localInfo.locale) {
      lang = this.localInfo.locale.substr(0, this.localInfo.locale.indexOf('_'));
    }

    language.lang = lang;
    translate.setDefaultLang(lang);
    translate.use(lang);
  }
}
